import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class FileTypeModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'service': id;
		'service.serviceUrn': Urn;
		'policy': id;
		'policy.reference': Website_StonecodeFilePolicyReference;
		'reference': Website_StonecodeFileTypeReference;
		'urnMask': id;
		'deprecated': string;
		'system': string;
	};

	static get path(): string {
		return 'stonecode_file_types/{?id}';
	}

	@doc.string declare reference: string;
}
